import ReactGA from "react-ga";

const trackingId = "G-X250EVLHSY";
ReactGA.initialize(trackingId);

export default ReactGA;
